var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04694 6.71923H1.48552C0.938155 6.71923 0.573242 6.35432 0.573242 5.80695V1.24553C0.573242 0.698165 0.938155 0.333252 1.48552 0.333252C2.03289 0.333252 2.39781 0.698165 2.39781 1.24553V4.89467H6.04694C6.59431 4.89467 6.95922 5.25958 6.95922 5.80695C6.95922 6.35432 6.59431 6.71923 6.04694 6.71923Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87148 17.6667C6.86797 17.6667 5.86446 17.4842 4.95217 17.1193C3.31006 16.4807 1.94164 15.3859 0.938128 13.9263C0.664443 13.4702 0.755671 12.9228 1.21181 12.6491C1.66795 12.3754 2.21532 12.4666 2.48901 12.9228C3.21883 14.0175 4.31357 14.9298 5.59077 15.3859C6.86797 15.8421 8.23639 15.9333 9.60481 15.5684C10.882 15.2035 12.068 14.3824 12.889 13.2877C13.7101 12.193 14.1662 10.9158 14.2575 9.54734C14.2575 8.17891 13.8925 6.81049 13.0715 5.71575C12.2504 4.62101 11.1557 3.79996 9.8785 3.34382C8.6013 2.88767 7.23288 2.88767 5.86446 3.34382C4.58726 3.79996 3.49252 4.62101 2.67146 5.71575C2.39778 6.17189 1.85041 6.26312 1.39427 5.98943C0.938128 5.71575 0.846899 5.07715 1.21181 4.71224C2.21532 3.25259 3.67498 2.15785 5.31708 1.61048C6.95919 1.06311 8.78376 1.06311 10.4259 1.61048C12.068 2.15785 13.5276 3.25259 14.5311 4.71224C15.5347 6.17189 16.082 7.814 15.9908 9.63857C15.9908 11.3719 15.3522 13.1052 14.2575 14.4737C13.1627 15.8421 11.7031 16.8456 9.96973 17.393C9.42236 17.5754 8.6013 17.6667 7.87148 17.6667Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearWhite);
export default __webpack_public_path__ + "static/media/clear_white.517840bccaaa3bf2976d0088622fa4c0.svg";
export { ForwardRef as ReactComponent };